function MenuAula5() {
  

    return (
      <>
        <nav>
            <ul>
              <li><a href="#Componentes-Estilizados">Componentes Estilizados</a></li>
              <li><a href="#Principais-vantagens">Principais vantagens</a></li>
              <li><a href="#Instalando-Styled-Components">Instalando Styled Components</a></li>
              <li><a href="#Como-usar-o-Styled-Components">Como usar o Styled Components</a></li>
              <li><a href="#Exemplo-mais-complexo">Exemplo mais complexo</a></li>
              <li><a href="#Exercício-Styled-Components">Exercício Styled Components</a></li>
            </ul>
          </nav>
      </>
    );
  }
  
  export default MenuAula5;